import { StoreImageEnum as e } from "../enums/store-image-enum.mjs";
const t = (c) => {
  switch (c) {
    case e.link_thumbnail:
    case e.optin_thumbnail:
    case e.product_download_thumbnail:
    case e.e_course_thumbnail:
    case e.physical_product_thumbnail:
      return 60;
    case e.profile:
      return 128;
    case e.product_download_cover:
    case e.e_course_cover:
    case e.physical_product_cover:
      return 300;
  }
}, o = (c) => {
  switch (c) {
    case e.link_thumbnail:
    case e.optin_thumbnail:
    case e.product_download_thumbnail:
    case e.e_course_thumbnail:
    case e.physical_product_thumbnail:
      return 60;
    case e.profile:
      return 128;
    case e.product_download_cover:
    case e.e_course_cover:
    case e.physical_product_cover:
      return 180;
  }
};
export {
  o as getStoreImageHeight,
  t as getStoreImageWidth
};
